import api from '@/services/api';

export default {
  //types: Charge, Credit, Deposit, Payment
  async getTransactionCategories(type, propertyId) {
    try {
      let response = await api.get(`Accounts/TransactionCategories/${type}${propertyId ? `?propertyId=${propertyId}` : ''}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  }
}
